function scrollToAboutMe() {
    const aboutMeSection = document.getElementById("about-me");
    aboutMeSection.scrollIntoView({ behavior: "smooth", block: "end" });
}
function scrollToCareer() {
    const careerSection = document.getElementById("career");
    careerSection.scrollIntoView({ behavior: "smooth", block: "start" });
}
function scrollToProjects() {
    const projectsSection = document.getElementById("projects");
    projectsSection.scrollIntoView({ behavior: "smooth", block: "start" });
}
function scrollToSkills() {
    const skillSection = document.getElementById("skills");
    skillSection.scrollIntoView({ behavior: "smooth", block: "start" });
}

export { scrollToAboutMe, scrollToCareer, scrollToProjects, scrollToSkills };
